import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';
import { WidgethelperService } from '../widgethelper.service';

@Injectable()
export class ProgresstrackingService {

  private hub: SignalRConnection;

  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) { }

  chartOptions() {
    return {
      tooltip: {
        trigger: 'item',
        axisPointer: {
          type: 'shadow'
        },
        formatter: this._widgetHelper.ProgresstrackingTooltip,
      },
      legend: {
        data: ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'],
        icon: 'circle',
        textStyle: {
          color: '#999',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      barWidth: 70,
      barCategoryGap: '20%',
      // grid: {
      //   bottom: 85
      // },
      xAxis: {
        type: 'category',
        data: ['Units', 'Orders'],
        offset: 10,
        axisLabel: {
          textStyle: {
            color: '#ccc',
          },
        },
      },
      yAxis: [{
        type: "value",
        axisLabel: {
          formatter: "{value}%",
          textStyle: {
            color: '#ccc',
          },
        }
        //,min:0.00000000001, 
      }],
      color: ['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8', '#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      series: [
        {
          name: 'OnHold',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Entered',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Committed',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Planned',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Released',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Picking',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Picked',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Loading',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Loaded',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        },
        {
          name: 'Shipped',
          type: 'bar',
          barWidth: '30',
          stack: 'Orders',
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log('Progress Tracking')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Progress Tracking';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        let broadcastProgressTracking$ = new BroadcastEventListener<any>('broadcastProgressTracking');
        widget.hub.listen(broadcastProgressTracking$);

        broadcastProgressTracking$.subscribe((result: any) => {
          console.log('broadcastProgressTracking', result);

          if (result.widgetid == widget.widgetId && result.widgetcreationtime == widget.widgetcreationtime) {
            widget.dataLoaded = false;
            widget.IfNoDataFound = result.IsNoDataFound;
            
            widget.chartOptions = this.chartOptions();
            widget.errorMessage = null;
            if (result.PickType == 'PreShip') {
              let totalorders = result.OrdersOnHold + result.OrdersEntered + result.OrdersCommitted + result.OrdersPlanned + result.OrdersReleased;
              let totalunits = result.UnitsOnHold + result.UnitsEntered + result.UnitsCommitted + result.UnitsPlanned + result.UnitsReleased;

              widget.chartOptions.series[0].data = this._commonService.convertData(result.OrdersOnHold, result.UnitsOnHold, totalorders, totalunits);
              widget.chartOptions.series[1].data = this._commonService.convertData(result.OrdersEntered, result.UnitsEntered, totalorders, totalunits);
              widget.chartOptions.series[2].data = this._commonService.convertData(result.OrdersCommitted, result.UnitsCommitted, totalorders, totalunits);
              widget.chartOptions.series[3].data = this._commonService.convertData(result.OrdersPlanned, result.UnitsPlanned, totalorders, totalunits);
              widget.chartOptions.series[4].data = this._commonService.convertData(result.OrdersReleased, result.UnitsReleased, totalorders, totalunits);
              widget.chartOptions.series[5].data = [];
              widget.chartOptions.series[6].data = [];
              widget.chartOptions.series[7].data = [];
              widget.chartOptions.series[8].data = [];
              widget.chartOptions.series[9].data = [];
              //console.log(result);
              widget.chartOptions.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released'];
            }
            else if (result.PickType == 'PostShip') {
              let totalorders = result.OrdersPicking + result.OrdersPicked + result.OrdersLoading + result.OrdersLoaded + result.OrdersShipped;
              let totalunits = result.UnitsPicking + result.UnitsPicked + result.UnitsLoading + result.UnitsLoaded + result.UnitsShipped;

              widget.chartOptions.series[0].data = [];
              widget.chartOptions.series[1].data = [];
              widget.chartOptions.series[2].data = [];
              widget.chartOptions.series[3].data = [];
              widget.chartOptions.series[4].data = [];
              widget.chartOptions.series[5].data = this._commonService.convertData(result.OrdersPicking, result.UnitsPicking, totalorders, totalunits);
              widget.chartOptions.series[6].data = this._commonService.convertData(result.OrdersPicked, result.UnitsPicked, totalorders, totalunits);
              widget.chartOptions.series[7].data = this._commonService.convertData(result.OrdersLoading, result.UnitsLoading, totalorders, totalunits);
              widget.chartOptions.series[8].data = this._commonService.convertData(result.OrdersLoaded, result.UnitsLoaded, totalorders, totalunits);
              widget.chartOptions.series[9].data = this._commonService.convertData(result.OrdersShipped, result.UnitsShipped, totalorders, totalunits);
              //console.log(result);
              widget.chartOptions.legend.data = ['Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
            } else {
              //console.log('Progresstracking result orders');
              //console.log(result);
              let totalorders = result.OrdersOnHold + result.OrdersEntered + result.OrdersCommitted + result.OrdersPlanned + result.OrdersReleased + result.OrdersPicking + result.OrdersPicked + result.OrdersLoading + result.OrdersLoaded + result.OrdersShipped;
              let totalunits = result.UnitsOnHold + result.UnitsEntered + result.UnitsCommitted + result.UnitsPlanned + result.UnitsReleased + result.UnitsPicking + result.UnitsPicked + result.UnitsLoading + result.UnitsLoaded + result.UnitsShipped;
              widget.chartOptions.series[0].data = this._commonService.convertData(result.OrdersOnHold, result.UnitsOnHold, totalorders, totalunits);
              widget.chartOptions.series[1].data = this._commonService.convertData(result.OrdersEntered, result.UnitsEntered, totalorders, totalunits);
              widget.chartOptions.series[2].data = this._commonService.convertData(result.OrdersCommitted, result.UnitsCommitted, totalorders, totalunits);
              widget.chartOptions.series[3].data = this._commonService.convertData(result.OrdersPlanned, result.UnitsPlanned, totalorders, totalunits);
              widget.chartOptions.series[4].data = this._commonService.convertData(result.OrdersReleased, result.UnitsReleased, totalorders, totalunits);
              widget.chartOptions.series[5].data = this._commonService.convertData(result.OrdersPicking, result.UnitsPicking, totalorders, totalunits);
              widget.chartOptions.series[6].data = this._commonService.convertData(result.OrdersPicked, result.UnitsPicked, totalorders, totalunits);
              widget.chartOptions.series[7].data = this._commonService.convertData(result.OrdersLoading, result.UnitsLoading, totalorders, totalunits);
              widget.chartOptions.series[8].data = this._commonService.convertData(result.OrdersLoaded, result.UnitsLoaded, totalorders, totalunits);
              widget.chartOptions.series[9].data = this._commonService.convertData(result.OrdersShipped, result.UnitsShipped, totalorders, totalunits);
              widget.chartOptions.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
            }
            //console.log(result);
            widget.chartOptions.series[0].stack = 'Orders';
            widget.chartOptions.series[1].stack = 'Orders';
            widget.chartOptions.series[2].stack = 'Orders';
            widget.chartOptions.series[3].stack = 'Orders';
            widget.chartOptions.series[4].stack = 'Orders';
            widget.chartOptions.series[5].stack = 'Orders';
            widget.chartOptions.series[6].stack = 'Orders';
            widget.chartOptions.series[7].stack = 'Orders';
            widget.chartOptions.series[8].stack = 'Orders';
            widget.chartOptions.series[9].stack = 'Orders';

            if (widget.IfNoDataFound) {
              widget.errorMessage = errorMessages.noWidgetData;
            }
            else {
              widget.errorMessage = null;
            }
          }
          //console.log(result)  ;
          widget.dataLoaded = true;
          this._commonService.lastUpdatedTime = result.LastUpdateTime;
        }
          , err => {
            console.log('listenFor broadcastProgressTracking error', err);
          }
        );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PROGRESSTRACKING";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })

      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });

  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "progressTracking",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PROGRESSTRACKING";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "progressTracking",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) { }
          console.log('deleteWidget progressTracking RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/progresstracking.service.ts